import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { localStorageManager } from "../utils/LocalStorageManager";

export const SessionContext = ({children} : {children : React.JSX.Element}) => {
    const [session,setSession] = useState(localStorageManager.get('sessionToken'))
    const logout = useCallback(()=>{
        const hds = window._env_.REACT_APP_HDS_HOST
        const auth = window._env_.REACT_APP_CUR_AUTH_CLBC
        window.location.href = `${hds}/login?redirect=${auth}`
    },[])

    useEffect(()=>{
        const init = async()=>{
            if(!session)
                {
                    try{
                        const res = await axios.get(`${window._env_.REACT_APP_HDS_HOST}/login/sessionToken`, {
                            withCredentials: true,
                        })
                        if (res && res.status === 200) {
                            setSession(res.data.sessionToken)
                        }
                        else
                        {
                            logout()
                        }
                    }
                    catch{
                        logout()
                    }
                }
        }
        init()
    },[])

    useEffect(()=>{
        if(session)
            localStorageManager.set('sessionToken',session)
    },[session])

    if(session)
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <>{children}</>
    return null
}